import React, { Component } from 'react'
import { Col, Row } from 'reactstrap'
import ModalForm from '../../comum/components/ModalForm'
import RadiobuttonGroup from '../../comum/components/RadiobuttonGroup'
import FormInputSimples from '../../comum/components/FormInputSimples'
import FormInputTelefoneDDD from '../../comum/components/FormInputTelefoneDDD'
import FormDatePicker from '../../comum/components/FormDatePicker'
import FormOnlyPositiveNumberSimples from '../../comum/components/FormNumberSimples'
import CadastroStore from '../stores/CadastroStore'
import moment from 'moment'
import { observer } from 'mobx-react'

@observer
export default class ModalCadastro extends Component {

    constructor(props) {

        super(props)

        this.controller = new CadastroStore(this.props.controller.service)

        this.handleSalvar = this.handleSalvar.bind(this)
    }

    handleSalvar() {
        this.controller.salvando = true
        if(
            !this.alertaTipoDocumento() &&
            !this.alertaNome() &&
            !this.alertaDocumento() &&
            !this.alertaData() &&
            !this.alertaEndereco() &&
            !this.alertaEmail() &&
            !this.alertaDdd() &&
            !this.alertaTelefone()
        ) {
            this.controller.enviar(this.props.controller.fecharCadastro, this.props.controller.mostrarMsgEnviar)
        }
    }

    alertaTipoDocumento() {
        if(this.controller.salvando && this.controller.tipoDoc === undefined) {
            return "Campo obrigatorio"
        }
        return false
    }
    
    alertaNome() {
        if(this.controller.salvando && this.controller.nome === "") {
            return "Campo obrigatorio"
        }
        return false
        
    }
    
    alertaDocumento() {
        if(this.controller.salvando) {
            if(this.controller.documento === "") {
                return "Campo obrigatório"
            } else if(this.controller.tipoDoc === "fisica" && this.controller.documento.length < 11) {
                return "CPF inválido"
            } else if(this.controller.tipoDoc === "juridica" && this.controller.documento.length < 14) {
                return "CNPJ inválido"
            }
        }
        return false
    }
    
    alertaData() {
        if(this.controller.salvando && this.controller.tipoDoc === "fisica" && this.controller.data === null) {
            return "Campo obrigatorio"
        }
        return false
    }
    
    alertaEndereco() {
        if(this.controller.salvando && this.controller.endereco === "") {
            return "Campo obrigatorio"
        }
        return false
    }
    
    alertaCep() {
        if(this.controller.salvando && this.controller.cep === "") {
            return "Campo obrigatorio"
        }
        return false
    }
    
    alertaEmail() {
        if(this.controller.salvando && this.controller.email === "") {
            return "Campo obrigatorio"
        }
        return false
    }
    
    alertaTelefone() {
        if(this.controller.salvando && (this.controller.telefoneNumero === "")) {
            return "Campo obrigatorio"
        }
        return false
    }

    alertaDdd() {
        if(this.controller.salvando && (this.controller.telefoneDdd === "")) {
            return "Campo obrigatorio"
        }
        return false
    }

    render() {
        return (
            <ModalForm
                salvando = {this.controller.enviando}
                onClickSalvar={this.handleSalvar}
                labelConfirmar="ENVIAR"
                onClickCancelar={this.props.controller.fecharCadastro}
            >
                <h2 className="px-3">Solicitação de Cadastro</h2>                
                <RadiobuttonGroup
                    titulo="Tipo de documento"
                    className="mb-1"
                    name="docType"
                    obrigatorio={true}
                    alerta={this.alertaTipoDocumento()}
                    onClick={(event) => this.controller.setTipoDoc(event.target.value)}
                    itens={[
                        { id: "fisica", value: "fisica", label: "Pessoa física", checked: this.controller.tipoDoc === "fisica" },
                        { id: "juridica", value: "juridica", label: "Pessoa juricica", checked: this.controller.tipoDoc === "juridica" }
                    ]}
                />
                <Row style={{padding:"0px", margin:"0px"}}>
                    {this.controller.tipoDoc === "fisica"
                    ?<FormInputSimples
                        xs={12} sm={12} md={12} lg={12} xl={12}
                        titulo="Nome completo"
                        className="mb-2"
                        obrigatorio={true}
                        alerta={this.alertaNome()}
                        dado={this.controller.nome}
                        onChange={(event) => this.controller.setNome(event.target.value)}
                    />
                    :<FormInputSimples
                        xs={12} sm={12} md={12} lg={12} xl={12}
                        titulo="Razão social"
                        className="mb-2"
                        obrigatorio={true}
                        alerta={this.alertaNome()}
                        dado={this.controller.nome}
                        onChange={(event) => this.controller.setNome(event.target.value)}
                    />
                    }
                    <FormOnlyPositiveNumberSimples
                        xs={12} sm={12} md={6} lg={6} xl={6}
                        titulo={this.controller.tipoDoc === "juridica" ? "CNPJ" : "CPF"}
                        className="mb-0"
                        limiteMaximo={this.controller.tipoDoc === "juridica" ? 14 : 11}
                        dado={this.controller.documento}
                        obrigatorio={true}
                        alerta={this.alertaDocumento()}
                        onChange={(event) => this.controller.setDocumento(event.target.value)}
                    />
                    {this.controller.tipoDoc === "fisica" ?                        
                        <FormDatePicker 
                            xs={12} sm={12} md={6} lg={6} xl={6}
                            titulo="Data de nascimento"
                            className="mb-0 bg-danger"
                            date={this.controller.data}
                            obrigatorio={true}
                            alerta={this.alertaData()}
                            uniqueId="DatEmissao"
                            onChange={this.controller.setData}
                        />
                        :
                        <FormInputSimples
                            xs={12} sm={12} md={6} lg={6} xl={6}
                            titulo="CEP"
                            className="mb-0"
                            dado={this.controller.cep}
                            obrigatorio={true}
                            alerta={this.alertaCep()}
                            onChange={(event) => this.controller.setCep(event.target.value)}
                        />
                    }                    
                </Row>                     
                <FormInputSimples
                        xs={12} sm={12} md={12} lg={12} xl={12}
                        titulo="Endereço"
                        className="mb-2"
                        dado={this.controller.endereco}
                        obrigatorio={true}
                        alerta={this.alertaEndereco()}
                        onChange={(event) => this.controller.setEndereco(event.target.value)}
                />               
                <Row style={{padding:"0px", margin:"0px"}}>
                    {this.controller.tipoDoc === "fisica" &&
                        <FormInputSimples
                            xs={12} sm={12} md={3} lg={3} xl={3}
                            titulo="CEP"
                            dado={this.controller.cep}
                            obrigatorio={true}
                            alerta={this.alertaCep()}
                            onChange={(event) => this.controller.setCep(event.target.value)}
                        />
                    }
                    <FormInputSimples
                        xs={12} sm={12} 
                        md={this.controller.tipoDoc === "fisica" ? 9 : 12} 
                        lg={this.controller.tipoDoc === "fisica" ? 9 : 12}  
                        xl={this.controller.tipoDoc === "fisica" ? 9 : 12} 
                        titulo="E-mail"
                        dado={this.controller.email}
                        obrigatorio={true}
                        alerta={this.alertaEmail()}
                        onChange={(event) => this.controller.setEmail(event.target.value)}
                    />
                    {process.env.rig && this.controller.tipoDoc === "juridica" &&    
                        <React.Fragment>
                            <FormInputSimples
                                xs={12} sm={12} md={12} lg={12} xl={12}
                                titulo="Nome para Contato"
                                className="mb-2"
                                dado={this.controller.contato}
                                obrigatorio={true}
                                alerta={this.alertaEndereco()}
                                onChange={(event) => this.controller.setContato(event.target.value)}
                            />
                            <FormInputSimples
                                xs={12} sm={12} md={12} lg={12} xl={12} 
                                titulo="E-mail (Opcional)"
                                dado={this.controller.emailOpcional}
                                onChange={(event) => this.controller.setEmailOpcional(event.target.value)}
                            />
                        </React.Fragment>                    
                    }       
                </Row>       
                <Row style={{padding:"0px", margin:"0px"}}>       
                <FormOnlyPositiveNumberSimples
                    titulo="DDD"
                    xs={12} sm={12} md={3} lg={3} xl={3}
                    dado={this.controller.telefoneDdd}
                    limiteMaximo={4}
                    obrigatorio={true}
                    alerta={this.alertaDdd()}
                    onChange={(event) => this.controller.setTelefoneDdd(event.target.value)}
                />  
                <FormOnlyPositiveNumberSimples
                    titulo="Telefone"
                    xs={12} sm={12} md={9} lg={9} xl={9}
                    dado={this.controller.telefoneNumero}
                    limiteMaximo={10}
                    obrigatorio={true}
                    alerta={this.alertaTelefone()}
                    onChange={(event) => this.controller.setTelefoneNumero(event.target.value)}
                />
                </Row>
            </ModalForm>
        )
    }
}



// WEBPACK FOOTER //
// ./src/modules/controleacesso/components/ModalCadastro.js